import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import messages from "../../../assets/locale/messages";
import DeleteModal from "../../../components/DeleteModal";
import EmptyState from "../../../components/EmptyState";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/Table";
import {
  getUsersInsideProgramRequest,
  removeUserFromProgram
} from "../../../store/Programs/actions";

const UsersList = ({ lang, showActions = true, programId }) => {
  const dispatch = useDispatch();
  const list = useSelector(
    (state) => state.programs.programUsers.users
  );
  const meta = useSelector(
    (state) => state.programs.programUsers.meta
  );
  const isLoading = useSelector((state) => state.loader);

  const [page, setPage] = useState(1);
  const perPage = 10;

  const {
    cols: { name, email },
    shared: { deleteLabel },
    programs: { removeUserMessage }
  } = messages[lang];

  useEffect(() => {
    function getDirectors() {
      dispatch(
        getUsersInsideProgramRequest({
          id: programId,
          page: 1,
          items: perPage
        })
      );
    }
    getDirectors();
  }, []);

  const handlePagination = (event, page) => {
    setPage(page);
    dispatch(
      getUsersInsideProgramRequest({
        id: programId,
        page: page,
        items: perPage
      })
    );
  };

  const [removeUserId, setRemoveUserId] = useState(0);
  const handleRemoveUser = () => {
    dispatch(
      removeUserFromProgram({ id: programId, userId: removeUserId })
    );
    setRemoveUserId(0);
  };

  return (
    <>
      <Table
        headlines={[name, email]}
        hasActions={showActions}
        rows={list.map((row) => (
          <TableRow className="table__row" key={row.id}>
            <TableCell className="table__cell" align="left">
              {row.first_name} {row.second_name}
            </TableCell>
            <TableCell className="table__cell" align="left">
              {row.email}
            </TableCell>
            {!!showActions && (
              <TableCell className="table__cell" align="right">
                <Tooltip title={deleteLabel}>
                  <span>
                    <IconButton
                      onClick={() => setRemoveUserId(row.id)}
                      aria-label="delete"
                    >
                      <DeleteIcon
                        className={`table__delete`}
                        fontSize="medium"
                      />
                    </IconButton>
                  </span>
                </Tooltip>
              </TableCell>
            )}
          </TableRow>
        ))}
      />
      {!isLoading && !list.length && <EmptyState />}
      {meta.pages > 1 && (
        <Pagination
          count={meta.pages}
          page={meta.currentPage || page}
          handleChange={handlePagination}
        />
      )}
      {!!removeUserId && (
        <DeleteModal
          isOpen={!!removeUserId}
          deleteMessage={removeUserMessage}
          handleCancel={() => setRemoveUserId(0)}
          handleDelete={handleRemoveUser}
        />
      )}
    </>
  );
};

UsersList.propTypes = {
  lang: PropTypes.string,
  programId: PropTypes.any,
  showActions: PropTypes.oneOfType([PropTypes.bool, PropTypes.any])
};

export default UsersList;
